"use client"
import { Box } from '@quintoandar-tokko/jopijs'
import Skeletons from '@/components/fichaInfo/skelenton/Skeleton';
import style from './datepicker.module.scss'

const WEEK_DAYS = [1, 2, 3, 4, 5, 6, 7]
const MONTH_DAYS = [-1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30]

export default function DatePickerSkeleton (props) {
  const { className, ...rest } = props

  return (
    <Box
      className={`${style.skeletonDatepicker} ${className}`}
      {...rest}
    >
      <Box className={style.skeletonDatepickerHeader}>
        <Skeletons width={12} height={32} borderRadius={8} />
        <Skeletons width={72} height={16} borderRadius={8} />
        <Skeletons width={12} height={32} borderRadius={8} />
      </Box>
      
      <Box className={style.skeletonDatepickerWeekDays}>
        {WEEK_DAYS.map(day => (
          <Skeletons key={day} width={24} height={12} borderRadius={8} />
        ))}
      </Box>
      
      <Box className={style.skeletonDatepickerMonthDays}>
        {MONTH_DAYS.map(day => (
          <Skeletons key={day} width={40} height={40} borderRadius={100} />
        ))}
      </Box>
    </Box>
  )
}
